import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputLayoutComponent } from './input-layout.component';

@NgModule({
  declarations: [InputLayoutComponent],
  imports: [
    CommonModule
  ],
  exports: [InputLayoutComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class InputLayoutModule { }